import TableTemplate from "../TableTemplate/tableTemplate";
import {
  IFreezeReleaseRequestsTableReport,
  IFreezeTablesProps,
  IFreezeTablesSearchParams,
} from "../../Interfaces/freeze";
import { CommonTableUI } from "../TableTemplate/common";
import { getFreezeReleaseRequestsTable } from "../../Requests/freeze";

const ReleaseRequests = ({ searchParam }: IFreezeTablesProps) => {
  return (
    <TableTemplate<IFreezeTablesSearchParams, IFreezeReleaseRequestsTableReport>
      refreshTableTime={5000}
      withSort
      getDataTable={(searchParam, offset, pageSize, sortingType) =>
        getFreezeReleaseRequestsTable(
          searchParam,
          offset,
          pageSize,
          sortingType || ""
        )
      }
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
        />
      )}
      searchParameters={searchParam}
    />
  );
};

export default ReleaseRequests;
